import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from '@/app/App';

// Ionic core styles first, then Fruitways tokens and the Ionic variable mapping so they win.
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@/theme/colors.css';
import '@/theme/typography.css';
import '@/theme/spacing.css';
import '@/theme/radii.css';
import '@/theme/elevation.css';
import '@/theme/motion.css';
import '@/theme/base.css';
import '@/theme/ionic.css';
import '@/theme/app.css';

// New versions install quietly and take effect on the next launch. No prompt, no reload mid-task.
registerSW({ immediate: true });

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
